import { Grid } from '@mui/material';
import React from 'react';
import { CircularSkeleton, RoundedSkeleton } from '../../Common/Skeleton';

function LoadingMessage({ own }: { own: boolean }) {
  return (
    <Grid
      gap="10px"
      display="flex"
      flexDirection="row"
      justifyContent={own ? 'flex-end' : 'flex-start'}
    >
      {!own && <CircularSkeleton height={36} width={36} variant="circular" />}
      <Grid
        gap="4px"
        display="flex"
        flexDirection="column"
        alignItems={own ? 'flex-end' : 'flex-start'}
      >
        <Grid
          bgcolor={own ? '#FFDDC8' : 'rgba(124, 174, 190, 0.15)'}
          borderRadius={own ? '20px 0px 20px 20px' : '0px 20px 20px 20px'}
          p={2}
          maxWidth={own ? 520 : 540}
          gap="6px"
        >
          <RoundedSkeleton height={14.875} width={497} />
          <RoundedSkeleton height={14.875} width={464} />
          <RoundedSkeleton height={14.875} width={451} />
        </Grid>
        <Grid gap="4px" alignItems="center" display="flex">
          <RoundedSkeleton height={10.5} width={15} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default LoadingMessage;
